import { requestJson } from "./apiClient";

export function getAccountConsents() {
  return requestJson("/api/account/consents");
}

export function acceptConsent(legalDocumentId, source) {
  return requestJson("/api/account/consents/accept", {
    method: "POST",
    body: JSON.stringify({ legalDocumentId, source }),
  });
}

export function acceptRequiredConsents(legalDocumentIds, source = "login") {
  return requestJson("/api/account/consents/accept-required", {
    method: "POST",
    body: JSON.stringify({ legalDocumentIds, source }),
  });
}

export function revokeConsent(legalDocumentId, source) {
  return requestJson("/api/account/consents/revoke", {
    method: "POST",
    body: JSON.stringify({ legalDocumentId, source }),
  });
}
